import { HeadBannerResponse } from '@shared/api/head-banner/headBanner.types'

export const SearchParamKey = {
    REF_CODE: 'ref_code',
    COMPANY_INVITE_ID: 'companyInviteId', // need to be changed to `company_invite_id` in banxe-dashboard
    ACCESS_TOKEN: 'access_token',
    REFRESH_TOKEN: 'refresh_token',
    REDIRECT_URL: 'redirectUrl', // need to be changed to `redirect_url` in banxe-dashboard
} as const

export type SearchParamKey = (typeof SearchParamKey)[keyof typeof SearchParamKey]

export interface IAppState {
    searchParams: Partial<Record<SearchParamKey, string | null | undefined>>
}

export type GlobalAlert = HeadBannerResponse & {
    show?: boolean,
}

export interface IAppSessionState extends IAppState {
    showGlobalAlert?: boolean
}

export type SearchParamsRecord = Record<SearchParamKey, string | null | undefined>

export const allSearchParamKeys: SearchParamKey[] = Object.values(SearchParamKey)

export const defaultSearchParams: SearchParamsRecord = Object.fromEntries(
    allSearchParamKeys.map((key) => [key, null])
) as SearchParamsRecord
